import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../AppContext';

function PatientProfile() {
    const navigate = useNavigate();
    const { state } = useAppContext();

    const patient = {
        email: state?.patientInfo?.email,
        first_name: state?.patientInfo?.first_name,
        last_name: state?.patientInfo?.last_name,
        found: true,
        mrn: "",
        patient_id: state?.patientId
    };

    return (
        <div
            className="page-card centered-card"
            style={{
                maxWidth: '700px',
                margin: '0 auto'
            }}
        >
            <div className="padding-lg">
                <h2 className="page-heading">
                    Patient Profile
                </h2>

                <div className="profile-container">

                    <div className="form-group">
                        <label className="form-label">
                            First Name
                        </label>
                        <input
                            type="text"
                            value={patient.first_name}
                            className="form-control"
                            readOnly
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Last Name
                        </label>
                        <input
                            type="text"
                            value={patient.last_name}
                            className="form-control"
                            readOnly
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Email
                        </label>
                        <input
                            type="email"
                            value={patient.email}
                            className="form-control"
                            readOnly
                        />
                    </div>

                    {/* <div className="form-group">
                        <label className="form-label">
                            MRN
                        </label>
                        <input
                            type="text"
                            value={patient.mrn}
                            className="form-control"
                            readOnly
                        />
                    </div> */}

                    <div className="form-group">
                        <label className="form-label">
                            Patient ID
                        </label>
                        <input
                            type="text"
                            value={patient.patient_id}
                            className="form-control"
                            readOnly
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Status
                        </label>
                        <input
                            type="text"
                            value={patient.found ? "Active" : "Not Found"}
                            className="form-control"
                            readOnly
                        />
                    </div>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate('/patient-dashboard')}
                    >
                        Back
                    </button>

                </div>
            </div>
        </div>
    );
}

export default PatientProfile;